import { render, staticRenderFns } from "./FacebookMessenger.vue?vue&type=template&id=d6216acc&"
import script from "./FacebookMessenger.vue?vue&type=script&lang=js&"
export * from "./FacebookMessenger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports